import { api } from "../api/requests";
import { ICreateSubscriptionPlan } from "../resources/interfaces";

// Get All Subscription Plans
export async function getAllSubscriptionPlans(pageNumber?: number, pageSize?: number, offset?: number, paged?: boolean, search?: string, sort?: { sorted: boolean, unsorted: boolean }, unpaged?: boolean): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans?pageNumber=${pageNumber}&pageSize=${pageSize}${offset ? `&offset=${offset}` : ''}${paged ? `&paged=${paged}` : ''}${search ? `&search=${search}` : ''}${sort ? `&sort.sorted=${sort?.sorted}&sort.unsorted=${sort?.unsorted}` : ''}${unpaged ? `&unpaged=${unpaged}` : ''}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Create a new subscription plan
export async function createSubscriptionPlan(subscriptionPlan: ICreateSubscriptionPlan): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/subscription-plans`, subscriptionPlan)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get subscription plan by ID
export async function getSubscriptionPlanById(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/${id}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Update subscription plan
export async function updateSubscriptionPlan(id: string, subscriptionPlan: ICreateSubscriptionPlan): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/subscription-plans/${id}`, subscriptionPlan)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Delete subscription plan
export async function deleteSubscriptionPlan(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.delete(`admin/subscription-plans/${id}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Activate subscription plan
export async function activateSubscriptionPlan(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/subscription-plans/${id}/activate`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Archive subscription plan
export async function archiveSubscriptionPlan(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/subscription-plans/${id}/archive`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Deactivate subscription plan
export async function deactivateSubscriptionPlan(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/subscription-plans/${id}/deactivate`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get active subscription plans
export async function getActiveSubscriptionPlans(): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/active`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get plans by billing cycle
export async function getPlansByBillingCycle(billingCycle: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/billing-cycle/${billingCycle}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get subscription plan by code
export async function getSubscriptionPlanByCode(planCode: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/code/${planCode}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get featured subscription plans
export async function getFeaturedSubscriptionPlans(): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/featured`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get public subscription plans
export async function getPublicSubscriptionPlans(): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/public`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Search plans by name
export async function searchPlansByName(name: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/search?name=${name}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get plan statistics
export async function getPlanStatistics(): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/statistics`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get plans by tier
export async function getPlansByTier(tier: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/subscription-plans/tier/${tier}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Company Subscribe to Plan
export async function subscribeToPlan(planId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/teams/subscribe/${planId}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}